import { createContext, useContext } from 'react';

/** The existing customer an application is being captured for, if any: lets steps read their settings. */
export const WizardCustomerContext = createContext<string | undefined>(undefined);

export const useWizardCustomerId = () => useContext(WizardCustomerContext);
